import React from 'react';
import Grid from '@material-ui/core/Grid';
import { Input } from '@DesignSystem/controllers';
import { Button } from '@material-ui/core';
import { RemoveMetricIcon } from '@Icons-outdated';
import { APIKeyInputWritable } from '@shared';

import classNames from './CustomizeOrganizationSettings.module.scss';

type Field = {
  id: string;
  secretName: string;
  secretValue: string;
};

type KeyValueListItemProps = {
  field: Field;
  id: string;
  isKeyDisabled: boolean;
  onChange: (id: string, updatedField: Omit<Field, 'id'>) => void;
  onRemove: (id: string) => void;
  isRemoveDisabled: boolean;
};

export const KeyValueListItem: React.FC<KeyValueListItemProps> = ({
  field,
  id,
  isKeyDisabled,
  onChange,
  onRemove,
  isRemoveDisabled
}) => {
  const handleKeyChange = (newKey: string): void => {
    onChange(id, { ...field, secretName: newKey });
  };

  const handleValueChange = (newValue: string): void => {
    onChange(id, { ...field, secretValue: newValue });
  };

  return (
    <Grid container spacing={1} alignItems="center">
      <Grid item className={classNames.fieldInputWrapper}>
        <Input
          onChange={handleKeyChange}
          name="secretName"
          value={field.secretName}
          placeholder="Enter name"
          className={classNames.fieldInput}
          fullWidth
          disabled={isKeyDisabled}
        />
      </Grid>
      <Grid item className={classNames.fieldInputWrapper}>
        <APIKeyInputWritable
          title=""
          onChange={handleValueChange}
          name="secretValue"
          value={field.secretValue}
          placeholder="Enter value"
          className={classNames.fieldInput}
          fullWidth
        />
      </Grid>
      <Grid item xs={1} className={classNames.removeButtonWrapper}>
        <Button
          variant="text"
          disabled={isRemoveDisabled}
          onClick={() => onRemove(id)}
          className={classNames.removeButton}
        >
          <RemoveMetricIcon />
        </Button>
      </Grid>
    </Grid>
  );
};
